import * as React from "react";

import { themed } from "../../../../Internals/ThemeProvider/ThemedWorkaround";
import { emptyRef } from "../../../../TypingUtils";

import * as styles from "./CrossfitTableSidebar.styles";

export interface CrossfitTableSidebarProps {
    children?: JSX.Element;
    colgroup: React.ReactNode;
    innerRef: (el: HTMLElement | null) => void;
    columns?: number;
    isReadOnly: boolean;
}

export class CrossfitTableSidebar extends React.Component<CrossfitTableSidebarProps> {
    public sidebar: null | HTMLElement = emptyRef;

    public render(): JSX.Element {
        return (
            <div css={styles.sidebarContainer} ref={this.refSidebar}>
                <table css={themed(styles.table, styles.sidebar)}>
                    {this.props.colgroup}
                    {this.props.isReadOnly !== true && <tbody>{this.props.children}</tbody>}
                </table>
            </div>
        );
    }

    private readonly refSidebar = (el: null | HTMLElement): void => {
        if (el) {
            this.sidebar = el;
            this.props.innerRef(el);
        }
    };
}
